import { useState } from "react";
import { useSelector } from "react-redux";
import "./newCompany.css";
import { registerCompany } from "../../redux/apiCalls";

export default function NewCompany() {
    const currentUser = useSelector((state) => state.user.currentUser);
    const [inputs, setInputs] = useState({});

    const handleChange = (e) => {
        setInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value };
        });
    };

    const handleClick = async (e) => {
        e.preventDefault();

        // Validate required address fields
        if (!inputs.lineOne || !inputs.zip || !inputs.city || !inputs.country) {
            alert("Address fields (Address Line 1, City, Zip Code, Country) are required");
            return;
        }

        // Determine principle based on current user
        let principleParam;
        if (currentUser?.isSuperAdmin) {
            // SuperAdmin can create companies without principle restriction
            principleParam = undefined;
        } else if (currentUser?.type === "outright" || currentUser?.type === "manager") {
            // Outright and manager users use their own _id as principle
            principleParam = currentUser._id;
        } else {
            // For other user types, use their principle if available
            principleParam = currentUser?.principle;
        }

        const company = { 
            ...inputs,
            principle: principleParam,
            createdBy: currentUser?._id,
        };
        
        try {
            await registerCompany({ company });
            alert("Company registered successfully!");
        } catch (err) {
            console.log(err);
            alert("Failed to register company. Please try again.");
        }
    }

    return (
        <>
            <div className="newProduct">
                <h1 className="addProductTitle">New Company</h1>
                <div className="addProductForm">
                    <div className="addProductItem">
                        <label>Creditor Code</label>
                        <input
                            name="debtorCode"
                            type="text"
                            placeholder="Creditor Code"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className=" required">Company Name</label>
                        <input
                            name="name"
                            type="text"
                            placeholder="Company Name"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label>Registration Number</label>
                        <input
                            name="ic"
                            type="text"
                            placeholder="Company Registration Number"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label>TIN</label>
                        <input
                            name="tin"
                            type="text"
                            placeholder="Tax Identification Number"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className=" required">Email</label>
                        <input
                            name="email"
                            type="text"
                            placeholder="Email"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className=" required">Phone Number</label>
                        <input
                            name="phoneNumber"
                            type="text"
                            placeholder="Phone Number"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className=" required">Address Line 1</label>
                        <input
                            name="lineOne"
                            type="text"
                            placeholder="Address Line 1"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label>Address Line 2</label>
                        <input
                            name="lineTwo"
                            type="text"
                            placeholder="Address Line 2 (Optional)"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className=" required">Zip Code</label>
                        <input
                            name="zip"
                            type="text"
                            placeholder="Zip Code"
                            onChange={handleChange}
                        />
                    </div>
                    <div className="addProductItem">
                        <label className=" required">City</label>
                        <input
                            name="city"
                            type="text"
                            placeholder="City"
                            onChange={handleChange}
                        />
                    </div>
                   
                    <div className="addProductItem">
                        <label className=" required">Country</label>
                        <input
                            name="country"
                            type="text"
                            placeholder="Country"
                            onChange={handleChange}
                        />
                    </div>
                    <button onClick={handleClick} className="updateProductButton formCreateButton">
                        Create
                    </button>
                </div>
            </div>
        </>
    );
}

